import React from "react";

/* Une réponse de l'assistant du site, mise en forme : la même dans la bulle du site et dans
   l'onglet « Tester » de la console. Le bot écrit un petit Markdown (listes « - », **gras**,
   liens [texte](https://…)) : on le traduit en éléments React, jamais en HTML brut.

   Les liens vers 1000arts.ch deviennent des liens internes (/planning…) : sur la version de
   test comme sur le vrai site, le visiteur reste sur le site qu'il est en train de visiter. */

const JETON = /(\[[^\]\n]+\]\(https?:\/\/[^)\s]+\)|https?:\/\/[^\s)»"<]+|\*\*[^*\n]+\*\*)/g;

function cible(url) {
  try {
    const u = new URL(url);
    if (/(^|\.)1000arts\.ch$/i.test(u.hostname)) return `${u.pathname}${u.search}${u.hash}` || "/";
  } catch { /* adresse illisible : laissée telle quelle */ }
  return url;
}

function Lien({ url, children, nouvelOnglet }) {
  const href = cible(url.replace(/[.,;:!?]+$/, ""));
  const externe = /^https?:/.test(href);
  return (
    <a href={href} className="underline font-medium" style={{ color: "#007E85", overflowWrap: "anywhere" }}
      {...(externe || nouvelOnglet ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
      {children}
    </a>
  );
}

function EnLigne({ texte, nouvelOnglet }) {
  return String(texte || "").split(JETON).map((m, i) => {
    const md = m.match(/^\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)$/);
    if (md) return <Lien key={i} url={md[2]} nouvelOnglet={nouvelOnglet}>{md[1]}</Lien>;
    if (/^https?:\/\//.test(m)) {
      const propre = m.replace(/[.,;:!?]+$/, "");
      return (
        <React.Fragment key={i}>
          <Lien url={propre} nouvelOnglet={nouvelOnglet}>{propre.replace(/^https?:\/\/(www\.)?/, "")}</Lien>
          {m.slice(propre.length)}
        </React.Fragment>
      );
    }
    if (/^\*\*[^*]+\*\*$/.test(m)) return <strong key={i}>{m.slice(2, -2)}</strong>;
    // Restes de Markdown isolés (*italique*, `code`) : on garde le texte, sans les signes.
    return <React.Fragment key={i}>{m.replace(/(^|\s)[*_]([^*_\n]+)[*_](?=\s|$|[.,;:!?])/g, "$1$2").replace(/`/g, "")}</React.Fragment>;
  });
}

export default function TexteAssistant({ texte, nouvelOnglet = false }) {
  const lignes = String(texte || "").replace(/\r/g, "").trim().split("\n");
  const blocs = [];
  lignes.forEach((brute, i) => {
    const l = brute.replace(/^#{1,6}\s*/, "").replace(/\s+$/, "");
    const puce = l.match(/^\s*(?:[-•*]|\d+[.)])\s+(.*)$/);
    if (puce) {
      blocs.push(
        <div key={i} className="flex gap-2 pl-0.5">
          <span aria-hidden style={{ color: "#00C6CE", lineHeight: "inherit" }}>•</span>
          <span className="min-w-0"><EnLigne texte={puce[1]} nouvelOnglet={nouvelOnglet} /></span>
        </div>);
    } else if (/^\*\*[^*]+\*\*:?$/.test(l.trim())) {
      // Une ligne entièrement en gras (« **Mercredi** ») : un petit intertitre.
      blocs.push(<div key={i} className="font-semibold pt-1">{l.trim().replace(/^\*\*|\*\*:?$/g, "")}</div>);
    } else if (!l.trim()) {
      if (blocs.length && blocs[blocs.length - 1].type !== "span") blocs.push(<span key={i} className="block h-2" />);
    } else {
      blocs.push(<div key={i}><EnLigne texte={l} nouvelOnglet={nouvelOnglet} /></div>);
    }
  });
  return <div className="space-y-0.5 leading-relaxed">{blocs}</div>;
}
